import React from 'react';
import { useNavigation } from '../../lib/navigation';
import { StartMeetingIcon } from '../icons/StartMeetingIcon';
import { JoinMeetingIcon } from '../icons/JoinMeetingIcon';
import { ScheduleIcon } from '../icons/ScheduleIcon';
import { RecordingsIcon } from '../icons/RecordingsIcon';
import { ROUTES } from '../../lib/routes';
import styles from '../../styles/AuthenticatedHome.module.css';

interface MenuItem {
  id: string;
  route: string;
  icon: React.ComponentType<{ className?: string }>;
  labelKey: string;
  disabled?: boolean;
  hidden?: boolean;
}

interface SidebarProps {
  translations: any;
  hideSchedule?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ translations, hideSchedule = false }) => {
  const navigation = useNavigation();
  const t = translations.home;

  const menuItems: MenuItem[] = [
    {
      id: 'create',
      route: ROUTES.MEETINGS_CREATE,
      icon: StartMeetingIcon,
      labelKey: 'createMeeting',
      disabled: false,
    },
    {
      id: 'join',
      route: ROUTES.MEETINGS_JOIN,
      icon: JoinMeetingIcon,
      labelKey: 'joinMeeting',
      // Temporarily hidden from the menu (feature on pause). Set hidden: false to restore.
      hidden: true,
    },
    {
      id: 'schedule',
      route: ROUTES.SCHEDULE,
      icon: ScheduleIcon,
      labelKey: 'schedule',
      disabled: false,
    },
    {
      id: 'recordings',
      route: ROUTES.RECORDINGS,
      icon: RecordingsIcon,
      labelKey: 'recordings',
      disabled: false,
    },
  ];

  const visibleMenuItems = menuItems.filter((item) => {
    if (item.hidden) return false;
    if (hideSchedule && item.id === 'schedule') return false;
    return true;
  });

  const handleMenuSelect = (path: string) => {
    navigation.push(path);
  };

  const isActive = (path: string) => {
    return (navigation.pathname || '').startsWith(path);
  };

  return (
    <aside className={styles.sidebar}>
      {visibleMenuItems.map((item) => {
        const Icon = item.icon;
        const isItemActive = isActive(item.route);
        const className = [
          styles.menuItem,
          item.disabled && styles.disabled,
          isItemActive && styles.selected
        ].filter(Boolean).join(' ');

        return (
          <div key={item.id} className={styles.menuItemWrapper}>
            <button
              className={className}
              onClick={() => handleMenuSelect(item.route)}
              disabled={item.disabled}
            >
              <Icon className={styles.menuIcon} />
            </button>
            <span className={styles.menuLabel}>{t[item.labelKey]}</span>
          </div>
        );
      })}
    </aside>
  );
};
